import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AppMessage } from './app-message';
import Swal, { SweetAlertPosition } from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class AppMessageService {
  private readonly _eventSource = new Subject<AppMessage>();
  public eventSource = this._eventSource.asObservable();

  constructor() {}



  successToast(
    header: string,
    message: string,
    toastDuration: number = 5000,
    toastPosition: SweetAlertPosition = 'top-right'
  ) {
    this.showToast(
      header,
      message,
      toastDuration,
      toastPosition,
      'success'
    );
  }

  infoToast(
    header: string,
    message: string,
    toastDuration: number = 5000,
    toastPosition: SweetAlertPosition = 'top-right'
  ) {
    this.showToast(
      header,
      message,
      toastDuration,
      toastPosition,
      'info'
    );
  }

  warningToast(
    header: string,
    message: string,
    toastDuration: number = 5000,
    toastPosition: SweetAlertPosition = 'top-right'
  ) {
    this.showToast(
      header,
      message,
      toastDuration,
      toastPosition,
      'warning'
    );
  }

  errorToast(
    header: string,
    message: string,
    toastDuration: number = 5000,
    toastPosition: SweetAlertPosition = 'top-right'
  ) {
    this.showToast(
      header,
      message,
      toastDuration,
      toastPosition,
      'error'
    );
  }

  private showToast(
    title: string ,
    message: string,
    timer: number,
    position: SweetAlertPosition,
    icon: 'success' | 'error' | 'warning' | 'info' = 'info'
  ) {
    let background;
    switch(icon){
      case 'success':
        background = 'rgba(58, 201, 119, 0.9)'; // Adjust opacity as needed
        break;
      case 'error':
        background = 'rgba(254, 94, 94, 0.9)';
        break;
      case 'info':
        background = 'rgba(113, 196, 221, 0.9)';
        break;
      case 'warning':
        background = 'rgba(255, 173, 37, 0.9)';
        break;
      default:
        background = 'rgba(113, 196, 221, 0.9)';
    }

    Swal.fire({
      title,
      text: message,
      icon,
      toast: true,
      position,
      showConfirmButton: false,
      timer: 3000,
      iconColor: "#fff",
      background: background,
      color: "#fff",
      timerProgressBar: true,
      showCloseButton: true,
    });
  }
}
